import React, { useContext, useState } from "react";
import embLabels from "../../config/emb-labels-en.json";
import ACTIONS from "./Design_Asset_Actions.json";
import Tooltip from "../../utils/Tooltip";

import { AssetBlockContext } from "../CustomHooks/ContextApi";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";

const UtilityAsset = () => {
  const {
    CBAssetList = [],
    siteType,
    clientType,
    architectureType,
    gsxExternalId,
    configData,
    defaultsMinMax,
    handleUtilityChange,
    updateUtilitytConfig,
    calculateMaxAvailableUtilityPower,
    CBAssetListDispatch,
    selectedValues,
    defaultCbData,
    handleCbAssetRequired,
    handlePmAssetRequired,
    projectKind,
  } = useContext(AssetBlockContext);
  const projectTypeValue = useProjectTypeValue();
  if(!configData?.configData) {
    return null;
  }
  const utilityChangeHandler = e => {
    handleUtilityChange(e);
  };
  const utilityUpdateHandler = e => updateUtilitytConfig(e);
  const isPowerMeterRequired = () => projectKind?.isMgaasAnsi;
  const [powerIsBetween, nominalPowerMin, nominalPowerMax] =
    calculateMaxAvailableUtilityPower();

  
 
  return (
    <div name="utility" className="col-md-12 p-0">
      <div className="col-md-12 pt-2 pl-0 se-white-background">
        <div className="col-md-12 pb-2 se-white-background ">
          <se-icon
            color="primary"
            className="se-icon icon_button se-life-green"
            size="medium"
          >
            segment_energy_infrastructure
          </se-icon>
          <span className="ml-2 bold">Utility</span>
        </div>
      </div>

      <div className="col-md-12 mt-1 mb-1 se-white-background align-middle se-border">
        <div className="row">
          <label className=" col-md-5 bold mt-2 mb-2 pl-2 se-font-14px">
            Asset Settings
          </label>
          <div className="col-md-7 mt-1 text-right">
            <button
              type="button"
              className="btn btn-sm se-btn-secondary"
              onClick={utilityUpdateHandler}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save Settings
            </button>
          </div>
        </div>


      </div>
      <div className="col-md-12 pt-2 pb-2 se-grey-background">
        {/* Commenting because for future Int in Daas ANSI */}

        {isPowerMeterRequired() && (
          <div className="form-group mb-1">
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="pmRequired"
                id="pmRequiredValidation"

                onChange={() => handlePmAssetRequired(selectedValues.selectedAsset)}
                value={
                  CBAssetList[selectedValues.selectedAsset].uiData.pmRequired
                }
                checked={
                  CBAssetList[selectedValues.selectedAsset].uiData.pmRequired
                }
              />
              <label
                className="custom-control-label line-height-25"
                htmlFor="pmRequiredValidation"
              >
                Enable resource energy monitoring
              </label>
              <Tooltip
                position="left"
                iconColor="secondary"
                iconSize="small"
                information="Once selected, a power meter will be added to this branch to allow accurate metering, or specific sub metering function"
              />
            </div>
            
          </div>
        )}
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm inputFocus"}
            id="exampleFormControlInput1"
            name="name"
            maxLength="50"
            value={configData?.configData?.name}
            onChange={utilityChangeHandler}
            placeholder="Name"
          />
          <div
            className="invalid-feedback-custom"
            style={!configData?.configData?.name ? {} : { display: "none" }}
          >
            {embLabels.nameRequired}
          </div>
          <div
            className="invalid-feedback-custom"
            style={configData?.configData?.name !== "" && !/^(?! )[A-Za-z0-9 ]*(?<! )$/.test(configData?.configData?.name) ? {} : { display: "none" }}
          >
            {embLabels.notallowedAlphanumericValues}
          </div>
        </div>
        {[embLabels.ISLANDABLE_GSX, embLabels.GRID_CONNECTED_GSX].includes(siteType) &&
          (architectureType === embLabels.PV_GENSET_ATS || architectureType === embLabels.PV_BESS_NR) && (
            <div className="form-group mb-1">
              <label htmlFor="exampleFormControlInput1">External ID</label>
              <input
                type="text"
                autoComplete="none"
                className="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="External ID"
                onChange={utilityChangeHandler}
                name="externalId"
                maxLength="64"
                value={gsxExternalId.utilityExternalId}
              />
            </div>
          )}

     {  !projectKind?.isNMGaaSETOEMOL && <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">Description</label>
          <input
            type="text"
            autoComplete="none"
            className="form-control form-control-sm"
            id="exampleFormControlInput1"
            placeholder="Description"
            onChange={utilityChangeHandler}
            name="description"
            maxLength="100"
            value={configData?.configData?.description}
          />
        </div>}

        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput2">
            Maximum Available Power (kW) <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput2"
            name="maximum_available_power"
            maxLength="8"
            value={configData?.configData?.maximum_available_power}
            onChange={utilityChangeHandler}
            placeholder="Maximum Available Power (kW)"
          />
          {(configData?.configData?.maximum_available_power === "" || (parseInt(configData?.configData?.maximum_available_power) === 0)) && (
            <div className="invalid-feedback-custom">
              Maximum Available Power (kW) is required.
            </div>
          )}
          {configData?.configData?.maximum_available_power !== "" &&
            !powerIsBetween ? (
            <div className="invalid-feedback-custom">
              Maximum Available Power should be in range( {nominalPowerMin} -
              {nominalPowerMax} kW).
            </div>
          ) : (
            ""
          )}
        </div>

        {projectTypeValue !== "NMGaaS ETO" && <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput2">
            Utility CO2 Emission Rate (g/kWh){" "}
            <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput2"
            name="utilityCO2"
            maxLength="4"
            value={configData?.configData?.utilityCO2}
            onChange={utilityChangeHandler}
            placeholder="Utility CO2 Emission Rate"
          />
          {configData?.configData?.utilityCO2 === "" && (
            <div className="invalid-feedback-custom">
              Utility CO2 Emission g/kWh is required.
            </div>
          )}

          {configData?.configData?.utilityCO2 !== "" &&
            (parseInt(configData?.configData?.utilityCO2) <
              defaultsMinMax.utilityCO2Min ||
              parseInt(configData?.configData?.utilityCO2) >
              defaultsMinMax.utilityCO2Max) && (
              <div className="invalid-feedback-custom">
                Utility CO2 Emission should be in range(
                {defaultsMinMax.utilityCO2Min} - {defaultsMinMax.utilityCO2Max}{" "}
                g/kWh).
              </div>
            )}
        </div>}


        {projectTypeValue === "NMGaaS ETO" &&
          <>
            <div className="row">
              <div className="col-md-12">
                <span htmlFor="exampleFormControlInput1">
                  Utility CO2 Emission Rate <span className="se-mandatory">*</span>
                </span>
              </div>
              <div>
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="custom-control custom-radio mt-1">
                        <input
                          type="radio"
                          id="emissionRateFixed"
                          className="custom-control-input islandableRadio  asCompatible"
                          value="Fixed"
                          name="co2_emission_rate_type"
                          checked={configData.configData.co2_emission_rate_type === "Fixed"}
                          onChange={utilityChangeHandler}
                        />
                        <label
                          className="custom-control-label line-height-25"
                          htmlFor="emissionRateFixed"
                        >
                          Fixed
                        </label>
                      </div>

                    </div>
                    <div className="col-md-6">
                      <div className="custom-control custom-radio mt-1">
                        <input
                          type="radio"
                          id="emissionRateDynamic"
                          className="custom-control-input islandableRadio  asCompatible"
                          value="Dynamic"
                          name="co2_emission_rate_type"
                          checked={configData.configData.co2_emission_rate_type === "Dynamic"}
                          onChange={utilityChangeHandler}
                        />
                        <label
                          className="custom-control-label line-height-25"
                          htmlFor="emissionRateDynamic"
                        >
                          Dynamic
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {configData.configData.co2_emission_rate_type === "Fixed" && <div className="col-md-12 mt-2">
                  <div className="form-group mb-1">
                    <label htmlFor="co2EmissionRate">
                      CO2 Emission Rate (g/KWh) <span className="se-mandatory">*</span>
                    </label>
                    <input
                      type="text"
                      autoComplete="none"
                      className={"form-control form-control-sm "}
                      id="co2EmissionRate"
                      name="co2_emission_rate"
                      maxLength="8"
                      value={configData.configData.co2_emission_rate}
                      onChange={utilityChangeHandler}
                      placeholder="CO2 Emission Rate (g/KWh)"
                    />
                    {(configData.configData.co2_emission_rate === "" || (parseInt(configData?.configData?.co2_emission_rate) === 0)) && (
                      <div className="invalid-feedback-custom">
                        CO2 Emission Rate (g/KWh) is required.
                      </div>
                    )}
                    
                  </div>
                </div>}
                {configData.configData.co2_emission_rate_type === "Dynamic" && <div className="col-md-12 mt-2">
                  <div className="form-group mb-1">
                    <label htmlFor="CO2Provider">
                      CO2 Provider<span className="se-mandatory">*</span>
                    </label>

                    <select
                      className="form-control form-control-sm"
                      name="CO2Provider"
                      id="CO2Provider"
                      value={configData.configData.co2Provider}
                      onChange={utilityChangeHandler}
                    >
                      {["Watt Time"].map(
                        (quantity) => (
                          <option value={quantity} key={quantity}>
                            {quantity}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div className="form-group mb-1">
                    <label htmlFor="CO2Unit">
                      CO2 Emission Unit<span className="se-mandatory">*</span>
                    </label>

                    <select
                      className="form-control form-control-sm"
                      name="co2_emission_unit"
                      id="CO2Unit"
                      value={configData.configData.co2_emission_unit}
                      onChange={utilityChangeHandler}
                    >
                      {["gram(g)", "kg(Kilo gram)", "lbs(Pound)"].map(
                        (quantity) => (
                          <option value={quantity} key={quantity}>
                            {quantity}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>}
              </div>
            </div>

          </>
        }
      </div>
    </div>
  );
};

export default UtilityAsset;

